<div class="d-flex my-4" [class.move-right]="inRepliesArea">
  <button
    operation-managed-control
    class="btn btn-link px-0 text-primary load-more-btn me-3"
    [attr.data-test-id]="'comment-load-more-btn-' + indexLabel"
    (click)="onLoadMore()"
  >
    <h4 class="mb-0">
      {{ 'POSTS_POST_DETAIL_INFO_COMMENT_LOAD_MORE_HINT' | translate }}
    </h4>
  </button>
  <button
    operation-managed-control
    class="btn btn-link px-0 text-primary load-all-btn"
    [attr.data-test-id]="'comment-load-all-btn-' + indexLabel"
    (click)="onLoadAll()"
  >
    <h4 class="mb-0">
      {{ 'POSTS_POST_DETAIL_INFO_COMMENT_LOAD_ALL_HINT' | translate }}
    </h4>
  </button>
</div>
